/**
 * True while the URL points at a specific marking.
 *
 * A `?marking=` link from the workspace names a more precise destination than
 * the node the URL selects. Reading views scroll their column to the selected
 * node on mount, which runs after rehydration has scrolled to the marking and
 * takes it straight back out of view — so that scroll stands aside here.
 */
export function useMarkingScrollTarget() {
  const route = useRoute()

  return computed(() => typeof route.query.marking === 'string' && route.query.marking.length > 0)
}
